import { useState, type FC } from "react";

import { KeyFacts } from "../../keyFacts";
import { useCaseIde } from "../context/CaseIdeContext";
import { useCaseDataOptional } from "../data/CaseDataContext";
import { CaseUploadDialog } from "../files/UploadDialog";

/** "Key Facts" open in the center pane; memos, forms and files it names open as tabs. */
export const KeyFactsPane: FC = () => {
  const { individualId, open, requestPrompt, revealInDraft } = useCaseIde();
  const fs = useCaseDataOptional()?.fs;
  const [uploading, setUploading] = useState(false);
  return (
    <div className="h-full min-h-0 w-full overflow-hidden bg-surface">
      <KeyFacts
        individualId={individualId}
        onOpen={open}
        onPrompt={requestPrompt}
        onReveal={(draftId, text) => revealInDraft(draftId, text)}
        onUpload={fs ? () => setUploading(true) : undefined}
      />
      {uploading && fs ? (
        <CaseUploadDialog
          open
          onOpenChange={(o) => !o && setUploading(false)}
          targetName="Case Files"
          parentId={null}
          onAdded={(nodes) => {
            fs.addNodes(nodes);
            void fs.refresh();
          }}
        />
      ) : null}
    </div>
  );
};
